import { render } from "./RequiredLabel.vue?vue&type=template&id=c17cb23e&scoped=true"
import script from "./RequiredLabel.vue?vue&type=script&lang=js"
export * from "./RequiredLabel.vue?vue&type=script&lang=js"

import "./RequiredLabel.vue?vue&type=style&index=0&id=c17cb23e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c17cb23e"]])

export default __exports__